import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import ActiveIngredientService from '../../services/activeIngredientService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ActiveIngredientFilterSettingsModel, ActiveIngredientGridModel, ActiveIngredientForGridModel }
  from "../../models/activeIngredient";

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any
}

interface IState {
  isLoading: boolean;
  error: any;
  activeIngredients: Array<ActiveIngredientForGridModel>
  selectedActiveIngredients: Array<ActiveIngredientForGridModel>;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  activeIngredientSettings: ActiveIngredientFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class ActiveingredientListDialog extends React.Component<IProps, IState> {

  activeIngredientService = new ActiveIngredientService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      activeIngredients: new Array<ActiveIngredientForGridModel>(),
      selectedActiveIngredients: new Array<ActiveIngredientForGridModel>(),
      activeIngredientSettings: new ActiveIngredientFilterSettingsModel()
    }
  }

  componentDidMount() {
    this.getAllActiveIngredients(this.state.from, this.state.numberOfRows);
  }

  getAllActiveIngredients(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.activeIngredientService.getAllActiveIngredients(from, numberOfRows, this.state.activeIngredientSettings).then(
      (data: ActiveIngredientGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          activeIngredients: data.activeingredients,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllActiveIngredients(startIndex, this.state.numberOfRows);
  }

  handleOkButton = event => {
    event.preventDefault();

    const selectedActiveIngredients = this.state.selectedActiveIngredients;

    this.props.okClick(selectedActiveIngredients);
  }

  handleCanselButton = () => {
    this.props.cancelClick();
  }

  render() {
    return (
      <Dialog header="Active Ingredients" responsive={true} width="60%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCanselButton}
        footer={
          <div>
            <Button label="Add" icon="pi pi-check" onClick={this.handleOkButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '400px', maxHeight: '550px', overflowY: 'auto' }}>
          <DataTable value={this.state.activeIngredients}
            paginator={true}
            lazy={true}
            rows={this.state.numberOfRows}
            first={this.state.from}
            selection={this.state.selectedActiveIngredients}
            totalRecords={this.state.totalRecordsCount}
            onPage={(event) => this.handleOnPageClick(event)}
            onSelectionChange={(e) => this.setState({ selectedActiveIngredients: e.data })}>
            <Column selectionMode="multiple" style={{ width: '3em' }} />
            <Column field="activeIngredientName" header="Name" />
            <Column field="genericINNName" header="Generic INN Name" />
            <Column field="commonChemicalName" header="Common Chemical Name" />
            <Column field="molecularFormula" header="Molecular Formula" />
          </DataTable>
        </div>
      </Dialog>
    )
  }

}

export default ActiveingredientListDialog;